import firebase from 'firebase'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBnNi8R3AMviCHuEZgJUwVw6f1gEa-6ZU4",
    authDomain: "ravimyteam.firebaseapp.com",
    databaseURL: "https://ravimyteam.firebaseio.com",
    projectId: "ravimyteam",
    storageBucket: "ravimyteam.appspot.com",
    messagingSenderId: "544148646942",
    appId: "1:544148646942:web:d0f2d0c9751eb6ebb1520f",
    measurementId: "G-HMZFVXR1L9"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig)
const db = firebaseApp.firestore()
const auth = firebase.auth()
const provider = new firebase.auth.GoogleAuthProvider()

export { auth, provider };
export default db;